import React from "react";
import { Box, Button, TablePagination, Tooltip } from "@mui/material";
import CloudDownloadIcon from "@mui/icons-material/CloudDownload";
import CapaSaldoConciliacao from "./CapaSaldoConciliacao";
import { exportacaoSaldoLiberada } from "./capaSaldo.util";
import styles from "./styles.module.css";

const MSG_EXPORT_BLOQUEADO =
  "Exporte apenas com diferença zerada (saldo conciliado).";

export default function RodapeConciliacaoExtrato({
  extrato,
  capaSaldo = null,
  pagina,
  tamanhoPagina,
  totalItens,
  desabilitado = false,
  tipoContabil,
  onPaginaChange,
  onTamanhoPaginaChange,
  onExportarDominio,
  onExportarProtheus,
  onFechar,
}) {
  const exportacaoLiberada = exportacaoSaldoLiberada(capaSaldo);
  const exportDisabled = desabilitado || !exportacaoLiberada;
  const tituloBloqueio = !exportacaoLiberada ? MSG_EXPORT_BLOQUEADO : "";

  return (
    <Box className={styles.rodapeConciliacao} component="footer">
      <Box className={styles.rodapeConciliacaoSaldos}>
        <CapaSaldoConciliacao extrato={extrato} capaSaldo={capaSaldo} />
      </Box>

      <Box className={styles.rodapeConciliacaoPaginacao}>
        <TablePagination
          rowsPerPageOptions={[5, 10, 50, 100]}
          component="div"
          count={totalItens}
          rowsPerPage={tamanhoPagina}
          page={pagina}
          onPageChange={onPaginaChange}
          onRowsPerPageChange={onTamanhoPaginaChange}
          labelRowsPerPage="Resultados por página:"
          backIconButtonProps={{ disabled: desabilitado }}
          nextIconButtonProps={{ disabled: desabilitado }}
          SelectProps={{ disabled: desabilitado }}
          sx={{
            overflow: "hidden",
            margin: 0,
            "& .MuiTablePagination-toolbar": {
              minHeight: 40,
              paddingLeft: 0,
              paddingRight: 0,
              flexWrap: "nowrap",
            },
            "& .MuiTablePagination-spacer": {
              flex: "0 0 0.5rem",
            },
            "& .MuiTablePagination-selectLabel, & .MuiTablePagination-displayedRows":
              {
                fontSize: "0.8125rem",
              },
          }}
        />
      </Box>

      <Box className={styles.rodapeConciliacaoBotoes}>
        {tipoContabil === "dominio" ? (
          <Tooltip title={tituloBloqueio}>
            <span>
              <Button
                className={styles.botoesConciliacao}
                variant="contained"
                onClick={onExportarDominio}
                disabled={exportDisabled}
                startIcon={<CloudDownloadIcon />}
              >
                Exportar Domínio
              </Button>
            </span>
          </Tooltip>
        ) : (
          <Tooltip title={tituloBloqueio}>
            <span>
              <Button
                className={styles.botoesConciliacao}
                variant="contained"
                onClick={onExportarProtheus}
                disabled={exportDisabled}
                startIcon={<CloudDownloadIcon />}
              >
                Exportar Protheus
              </Button>
            </span>
          </Tooltip>
        )}
        <Button
          className={styles.botaoPopupCancelar}
          onClick={onFechar}
        >
          Fechar
        </Button>
      </Box>
    </Box>
  );
}
